import React from 'react';
import ProfitLoss from './Profit_Loss';
import '../../../CommonCSS/SocietyCSS.css'

const ProfitLossApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Profit and Loss Statement</h5>
          </div>
        </div>
        <ProfitLoss />
      </div>
    </div >
  );
};

export default ProfitLossApp;
